import { CookieConsentType } from '../models/cookie-consent-type.enum';

function optInStatistics() {
  localStorage.setItem('78b9b1fe-b589-4cb3-af4e-aae70e955cb5', 'true');
}

export function optIn(consentType: CookieConsentType) {
  switch (consentType) {
    case CookieConsentType.Statistics:
      return optInStatistics();
    default:
      break;
  }
}
